import { Upload } from 'element-ui'

const YUpload = Upload
YUpload.$depends = [Upload]
YUpload.$name = 'y-upload'
YUpload._name = 'Upload 上传'

export default YUpload
